// app/frontend/components/ui/Navigation/SpotlightSearch.tsx
import React from "react";
import { Spotlight, SpotlightActionData } from "@mantine/spotlight";
import { IconSearch, IconLoader2 } from "@tabler/icons-react";
import "./spotlight.css";

interface SpotlightSearchProps {
  actions: SpotlightActionData[];
  onSearchChange: (query: string) => void;
  isSearching?: boolean;
}

const SpotlightSearch: React.FC<SpotlightSearchProps> = ({
  actions,
  onSearchChange,
  isSearching = false,
}) => {
  return (
    <Spotlight
      actions={actions}
      onQueryChange={onSearchChange}
      shortcut={["mod + K"]}
      searchProps={{
        placeholder: "Search videos, tracks, categories...",
        leftSection: isSearching ? (
          <IconLoader2
            strokeWidth={2}
            color="#FF9800"
            style={{
              width: "20px",
              height: "20px",
              animation: "spin 1s linear infinite",
            }}
          />
        ) : (
          <IconSearch
            strokeWidth={2}
            color="#FF9800"
            style={{ width: "20px", height: "20px" }}
          />
        ),
      }}
      nothingFound={isSearching ? "Searching..." : "No results found"}
      highlightQuery
      classNames={{
        root: "spotlight-root",
        content: "spotlight-content",
        search: "spotlight-search",
        actionsList: "spotlight-actions-list",
        actionsGroup: "spotlight-actions-group",
        action: "spotlight-action",
        actionBody: "spotlight-action-body",
        actionLabel: "spotlight-action-label",
        actionDescription: "spotlight-action-description",
        actionSection: "spotlight-action-section",
        empty: "spotlight-empty",
      }}
      styles={{
        content: {
          background: "rgba(15, 15, 15, 0.75)",
          backdropFilter: "blur(24px)",
        },
        action: {
          background: "rgba(40, 40, 40, 0.6)",
          width: "100%",
          backdropFilter: "blur(8px)",
        },
        actionLabel: {
          fontSize: "14px",
        },
        actionDescription: {
          fontSize: "12px",
        },
      }}
      scrollable
      maxHeight={400}
    />
  );
};

export default SpotlightSearch;
